import { Component, input } from '@angular/core';
import { FieldState } from '@angular/forms/signals';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputError } from 'excellence-ui';

@Component({
  selector: 'app-field-errors',
  imports: [InputError, TranslocoPipe],
  templateUrl: './field-errors.html',
})
export class FieldErrors {
  fieldState = input.required<FieldState<unknown>>();
  alwaysShowErrors = input<boolean>(false);
}
